var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7135 12.2762C23.7135 11.4605 23.6474 10.6403 23.5063 9.83783H12.1875V14.4588H18.6692C18.4003 15.9492 17.536 17.2676 16.2705 18.1053V21.1037H20.1375C22.4083 19.0137 23.7135 15.9271 23.7135 12.2762Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 24.0009C15.4239 24.0009 18.1533 22.9382 20.1419 21.1039L16.2749 18.1056C15.1991 18.8375 13.8101 19.252 12.1919 19.252C9.06127 19.252 6.40685 17.1399 5.45444 14.3003H1.46399V17.3913C3.5011 21.4434 7.65028 24.0009 12.1875 24.0009Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45004 14.3004C4.94738 12.81 4.94738 11.1962 5.45004 9.70587V6.61493H1.464C-0.238001 10.0057 -0.238001 14.0006 1.464 17.3913L5.45004 14.3004Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 4.74966C13.8983 4.7232 15.5518 5.36697 16.7908 6.54867L20.2169 3.12262C18.0475 1.0855 15.1682 -0.034466 12.1875 0.000808666C7.65028 0.000808666 3.5011 2.55822 1.46399 6.61481L5.45003 9.70575C6.39803 6.86173 9.05686 4.74966 12.1875 4.74966Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.e3bf8b489809f41c59375e73efb87782.svg";
export { ForwardRef as ReactComponent };